import { useState } from "react";
import "../styles/faq.css";

const faqData = [
    {
        question: "How can I track my order?",
        answer: "Once we dispatch your order, we will send the tracking ID to your registered email address or contact you directly.",
    },
    {
        question: "Do you provide Cash on Delivery (COD)?",
        answer: "Currently, we support prepaid orders only. Please contact us for special cases.",
    },
    {
        question: "How can I share my pictures for customization?",
        answer: "You can share your images via WhatsApp after placing the order.",
    },
    {
        question: "Do you offer international shipping?",
        answer: "Currently, we only ship within India.",
    },
    {
        question: "How much time does delivery take?",
        answer: "Delivery usually takes 3–7 working days depending on location.",
    },
    {
        question: "Is it possible to receive my order within 2–3 days?",
        answer: "Yes, express delivery is available for selected locations. Extra charges will be included.",
    },
];

const LeafIcon = () => (
    <svg width="22" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 13 C8 8 12 5 18 5 C18 11 15 16 8 13Z" fill="#8aaf6e" />
        <path d="M8 13 C8 16 10 19 13 20" stroke="#5a7a4a" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
);

export default function FAQ() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <h2 className="faq-title">
                Frequently <em>Asked</em> Questions
            </h2>

            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div key={index} className="faq-item">

                        <div
                            className={`faq-question ${activeIndex === index ? "active" : ""}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <span>{item.question}</span>
                            <span className={`faq-icon ${activeIndex === index ? "active" : ""}`}>
                                <LeafIcon />
                            </span>
                        </div>

                        <div className={`faq-answer ${activeIndex === index ? "open" : ""}`}>
                            <div className="faq-answer-content">
                                {item.answer}
                            </div>
                        </div>

                    </div>
                ))}
            </div>
        </section>
    );
}